import LoadingCircle from "../../components/LoadingCircle";


export default class PasswordUpdate {

    constructor() {
        this.updatePassowrdForm = $('#password-update-form')
        this.updatePasswordFormBtn = $('#password-update-form button[type="submit"]')
        this.events()
    }

    events() {
        this.updatePassowrdForm.on('submit', e => this.passwordChangeSubmit(e))
    }

    passwordChangeSubmit(e) {
        this.loadingCircle = new LoadingCircle()
        this.loadingCircle.buttonShow(this.updatePasswordFormBtn)
    }

}
